import { InputSelect, Input, Textarea } from '~/components/primitives';
import { cn } from '~/utils';

export declare namespace getInputComponent {
    export type FieldType = 'text' | 'password' | 'select' | 'textarea';
    export interface ComponentProps<T extends string> {
        type: FieldType;
        field: T;
        value: any;
        handleChange: (field: T, value: any) => void;
        options?: { [key: string]: string }[];
        className?: string;
        disabled?: boolean;
        placeholder?: string;
        id?: string;
    }
}

/** @TODO: make this a component */
export const getInputComponent = <T extends string>({
    type,
    field,
    value,
    handleChange,
    options,
    disabled,
    placeholder,
    className = 'text-blue',
    id,
}: getInputComponent.ComponentProps<T>) => {
    const props = {
        value,
        disabled,
        className,
        name: field,
        onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            handleChange(field, e.target.value),
    };

    return type === 'text' ? (
        <Input {...props} />
    ) : type === 'password' ? (
        <Input type="password" {...props} />
    ) : type === 'textarea' ? (
        <Textarea {...props} />
    ) : type === 'select' ? (
        <InputSelect
            {...props}
            options={options || []}
            placeholder={placeholder}
            className={cn('w-full justify-between', className)}
            id={id}
            onChange={value => {
                if (value === '') return;
                handleChange(field, value);
            }}
        />
    ) : (
        'Form type not supported'
    );
};
